import styled, { css } from 'styled-components';
import { Modal, Divider, Select, Form, Icon, DatePicker, Input } from 'antd';
import {
  DataHeading,
  UnderlineLink,
  SectionLastHeading,
  DisplayFlex,
  GhostButtonComponent,
  SecondaryButtonComponent,
  CommonTable,
  LinkTo,
  PagesHeading,
  InputField,
  ErrorMessage
} from '../../../../CommonComponents/commonStyles';
import theme from '../../../../styles/theme';

export const ImpactContainer = styled.div`
  margin-top: 170px;
`;

export const Spinner = styled.div`
  top: -14px;
  border-radius: 50%;
  width: 2.5em;
  height: 2.5em;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation: load7 1.8s infinite ease-in-out;
  animation: load7 1.8s infinite ease-in-out;
  :before,
  :after {
    border-radius: 50%;
    width: 2.5em;
    height: 2.5em;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    -webkit-animation: load7 1.8s infinite ease-in-out;
    animation: load7 1.8s infinite ease-in-out;
  }
  color: #ffffff;
  font-size: 6px;
  position: relative;
  text-indent: -9999em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;

  :before,
  :after {
    content: '';
    position: absolute;
    top: 0;
  }
  :before {
    left: -3.5em;
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }
  :after {
    left: 3.5em;
  }
  @-webkit-keyframes load7 {
    0%,
    80%,
    100% {
      box-shadow: 0 2.5em 0 -1.3em;
    }
    40% {
      box-shadow: 0 2.5em 0 0;
    }
  }
  @keyframes load7 {
    0%,
    80%,
    100% {
      box-shadow: 0 2.5em 0 -1.3em;
    }
    40% {
      box-shadow: 0 2.5em 0 0;
    }
  }
`;

export const LinkToSamll = styled(LinkTo)`
  font-family: ${(props) => props.theme.fontFamily.helveticaNeue};
  font-size: ${(props) => props.theme.fontSize.secondary} !important;
  @media only screen and (min-width: 992px) {
    font-size: ${(props) => props.theme.fontSize.primary} !important;
  }
`;

export const LabelDataHeading = styled(DataHeading)`
  color: ${(props) => props.theme.fontColors.textColor};
`;
export const ValueDataHeading = styled(DataHeading)`
  color: ${(props) => props.theme.fontColors.headingColor};
  font-family: ${(props) => props.theme.fontFamily.helveticaNeueBold};
`;

export const GrantsTable = styled(CommonTable)`
  &&& .geminiColor {
    background-color: ${theme.backgroundColor.oleGeminiColor} !important;
  }

  .ant-table-row:nth-child(2n + 1) .geminiColor {
    background-color: ${theme.backgroundColor
      .gdpTableAlternatColor} !important ;
  }

  ${({ ColorLess, theme }) =>
    ColorLess &&
    css`
      .ant-table-row:nth-child(2n + 1) {
        background-color: ${theme.backgroundColor.layoutLight} !important;
      }
      .ant-table-tbody > tr > td {
        border-bottom: 1px solid ${theme.backgroundColor.layoutLight} !important;
      }
    `}
`;

export const FooterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  ${({ Main, theme }) =>
    Main &&
    `
		align-items: center;
    padding: 25px 0 50px 0;
    border-top: 1px solid ${theme.colors.border};
    @media (max-width: 990.98px) {
      flex-direction: column;
      align-items: flex-start;
      padding: 20px 0 20px 0;
    }
  `}
  ${({ EditableFooter, theme }) =>
    EditableFooter &&
    `
  align-items: center;
  padding: 22px 0 22px 0;
  border-top: 1px solid ${theme.border.pill};
  border-bottom: 1px solid ${theme.border.pill};
  @media (max-width: 990.98px) {
    align-items: flex-start;
    padding: 20px 0 20px 0;
  }
`}
${({ leftAlign }) =>
  leftAlign &&
  `
    margin-left: auto;
    @media (max-width: 990.98px) {
      margin-left: unset;
    }
    `}
  ${({ Button }) =>
    Button &&
    `
  >a {
    padding-right: 50px;
    >div:nth-child(2) {
      margin-left: 5px;
    }
  }
  @media (max-width: 990.98px) {
    flex-direction: column;
    align-items: flex-start;
    >a {
      padding-right: 0px;
      padding-top: 20px;
    }
  }
`}
`;

export const FooterContent = styled.div`
  padding-left: 21px;
  display: flex;
  > div {
    font-size: ${(props) => props.theme.fontSize.primary};
    line-height: ${(props) => props.theme.lineHeight.primary};
    color: ${(props) => props.theme.fontColors.thead};
    font-family: ${(props) => props.theme.fontFamily.helveticaNeue};
  }
  > p {
    font-size: ${(props) => props.theme.fontSize.primary};
    line-height: ${(props) => props.theme.lineHeight.primary};
    color: ${(props) => props.theme.fontColors.headingColor};
    font-family: ${(props) => props.theme.fontFamily.helveticaNeueBold};
    padding-left: 100px;
    margin: 0;
  }
  @media (max-width: 990.98px) {
    padding-left: 0px;
    flex-direction: column;
    > p {
      padding-left: 0px;
      padding-bottom: 1px;
    }
  }
`;

export const UnderlyingContent = styled(UnderlineLink)`
  font-family: ${(props) => props.theme.fontFamily.helveticaNeue};
  font-size: ${(props) => props.theme.fontSize.secondary} !important;
  font-style: ${(props) => props.theme.fontWeight.normal};
  font-stretch: ${(props) => props.theme.fontStretch.normal};
  line-height: ${(props) => props.theme.lineHeight.primary};
  letter-spacing: ${(props) => props.theme.letterSpacing.zero};
  color: ${(props) => props.theme.fontColors.primary};
  @media only screen and (min-width: 992px) {
    font-size: ${(props) =>
      props.tableFont
        ? props.theme.fontSize.tableFont
        : props.theme.fontSize.primary} !important;
  }
`;

export const GeminiName = styled.div`
  font-family: ${(props) => props.theme.fontFamily.helveticaNeue};
  font-size: ${(props) => props.theme.fontSize.primary};
  font-style: ${(props) => props.theme.fontWeight.normal};
  font-stretch: ${(props) => props.theme.fontStretch.normal};
  line-height: ${(props) => props.theme.lineHeight.primary};
  letter-spacing: ${(props) => props.theme.letterSpacing.normal};
  color: ${(props) => props.theme.fontColors.primary};
`;

export const TableLabel = styled.div`
  font-family: ${(props) => props.theme.fontFamily.helveticaNeue};
  font-size: ${(props) =>
    props.tableFont
      ? props.theme.fontSize.tableFont
      : props.theme.fontSize.primary};
  font-weight: ${(props) => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${(props) => props.theme.fontStretch.normal};
  line-height: ${(props) => props.theme.lineHeight.primary};
  letter-spacing: ${(props) => props.theme.letterSpacing.zero};
  color: ${(props) => props.theme.fontColors.textColor};
  @media only screen and (max-width: 990px) {
    font-size: ${(props) => props.theme.fontSize.secondary};
    line-height: ${(props) => props.theme.lineHeight.secondary};
  }
`;

export const CustomModal = styled(Modal)`
  .ant-modal-header {
    padding: 0px 0px 30px 0px;
    border-bottom: 2px solid ${(props) => props.theme.colors.border};
    @media only screen and (max-width: 991px) {
      padding: 0px 0px 15px 0px;
    }
  }
  .ant-modal-footer {
    padding: 30px 0px 0px 0px;
    display: flex;
    justify-content: center;
    text-align: center;
    @media only screen and (max-width: 991px) {
      margin-top: auto;
    }
  }
  .ant-modal-body {
    padding: ${(props) => props.padding};
    @media only screen and (max-width: 991px) {
      overflow-y: auto;
      ${(props) => (props.maxHeight ? 'max-height: 300px' : '')};
    }
  }
  .ant-modal-close-x {
    @media only screen and (max-width: 576px) {
      font-size: ${(props) => props.theme.fontSize.advisorCount};
    }
  }
  .ant-modal-content {
    border-radius: 0px;
    padding: 30px;
    @media only screen and (max-width: 991px) {
      padding: 30px 20px;
    }

    @media only screen and (max-width: 991px) {
      height: 100%;
      display: flex;
      flex-direction: column;
    }
  }
  @media only screen and (max-width: 991px) {
    width: 98% !important;
    height: 97vh;
    top: 10px;
    padding: 0;
  }
`;
export const ModalHeading = styled.div`
  font-family: ${(props) => props.theme.fontFamily.berkeleyStd};
  font-size: ${(props) => props.theme.fontSize.h5};
  font-style: normal;
  font-stretch: ${(props) => props.theme.fontStretch.normal};
  line-height: ${(props) => props.theme.lineHeight.oneP17};
  letter-spacing: ${(props) => props.theme.letterSpacing.normal};
  color: ${(props) => props.theme.fontColors.headingColor};
  text-align: center;
  @media only screen and (min-width: 992px) {
    font-size: ${(props) => props.theme.fontSize.h4};
  }
`;

export const ContentDivider = styled(Divider)`
  border: ${(props) => props.theme.backgroundColor.tableAltRowDark};
  margin-top: ${(props) => (props.small ? '10px' : '20px')};
  margin-bottom: ${(props) => (props.small ? '10px' : '15px')};
`;
export const Note = styled.div`
  font-family: ${(props) => props.theme.fontFamily.helveticaNeue};
  font-size: ${(props) => props.theme.fontSize.primary};
  line-height: ${(props) => props.theme.lineHeight.primary};
  color: ${(props) => props.theme.fontColors.textColor};
  ul {
    padding-top: 1rem;
  }
  li {
    list-style: disc;
    @media only screen and (max-width: 991px) {
      font-size: ${(props) => props.theme.fontSize.secondary};
    }
  }
`;
export const ItemHeading = styled.div`
  font-family: ${(props) => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${(props) => props.theme.fontSize.primary};
  line-height: ${(props) => props.theme.lineHeight.primary};
  color: ${(props) => props.theme.fontColors.headingColor};
  @media only screen and (max-width: 991px) {
    font-size: ${(props) => props.theme.fontSize.secondary};
  }
`;

export const CardPopContainer = styled.div`
  overflow-y: auto;
`;

export const SectionHeading = styled(SectionLastHeading)`
  font-stretch: normal;
  font-family: ${(props) => props.theme.fontFamily.helveticaNeueBold};
  line-height: ${(props) => props.theme.lineHeight.primary};
  font-size: ${(props) => props.theme.fontSize.primary} !important;
  letter-spacing: ${(props) => props.theme.letterSpacing.zero};
  color: ${(props) => props.theme.fontColors.headingColor};
`;

const headingStyle = css`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h4};
  color: ${props => props.theme.fontColors.headingColor}!important;
  letter-spacing: ${(props) => props.theme.letterSpacing.normal};
  margin-bottom: 15px !important;
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.h5};
    line-height: ${props => props.theme.lineHeight.h5};
  }
  @media only screen and (max-width: 576px) {
    line-height: ${props => props.theme.lineHeight.heading};
  }
`;

export const FindCharitySectionHeading = styled.h1`
  ${headingStyle}
  font-size: ${(props) =>
    props.findCharity ? props.theme.fontSize.h1 : props.theme.fontSize.h4};
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    font-size: ${(props) =>
      props.findCharity ? props.theme.fontSize.h2 : props.theme.fontSize.h5};
  }
`;

export const GrantSectionHeading = styled.h2`
  ${headingStyle}
  font-size: ${(props) =>
    props.findCharity ? props.theme.fontSize.h1 : props.theme.fontSize.h4};
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    font-size: ${(props) =>
      props.findCharity ? props.theme.fontSize.h2 : props.theme.fontSize.h5};
  }
`;

// Adding H3 tag for accessibility issue, 
export const GrantSectionHeading2 = styled.h2`
  ${headingStyle}
  font-size: ${(props) =>
    props.findCharity ? props.theme.fontSize.h1 : props.theme.fontSize.h4};
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    font-size: ${(props) =>
      props.findCharity ? props.theme.fontSize.h2 : props.theme.fontSize.h5};
  }
`;
export const GrantSectionSubHeading = styled.h2`
  p {
    display: inline;
    margin: 0;
  }
  a {
    font-family: ${(props) => props.theme.fontFamily.helveticaNeue};
    font-size: ${(props) => props.theme.fontSize.primary};
    line-height: ${(props) => props.theme.lineHeight.normal};
    color: rgb(0, 103, 120) !important;
    text-decoration: underline;
  }
  font-family: ${(props) => props.theme.fontFamily.helveticaNeue};
  font-size: ${(props) => props.theme.fontSize.secondary} !important;
  color: ${(props) => props.theme.fontColors.thead};
  line-height: 1.5rem !important;
  letter-spacing: 0px;
  padding: 0px 0px 20px 0px;
  margin-bottom: 0px !important;
  @media only screen and (min-width: 992px) {
    font-size: ${(props) => props.theme.fontSize.primary} !important;
  }
`;

export const SectionMediumDivider = styled(Divider)`
  border-bottom: solid 1px ${(props) => props.theme.colors.border};
  top: unset;
  margin-top: ${(props) => (props.smallMarginTop ? '30px' : '40px')};
  margin-bottom: ${(props) => (props.smallMarginBottom ? '30px' : '20px')};
  @media only screen and (min-width: 992px) {
    margin-top: ${(props) => (props.smallMarginTop ? '30px' : '49px')};
    margin-bottom: ${(props) => (props.smallMarginBottom ? '30px' : '50px')};
  }
`;

export const CharitySectionDivider = styled(Divider)`
  border-bottom: solid 1px ${(props) => props.theme.colors.border};
  top: unset;
  margin-top: 20px;
  margin-bottom: 20px;
  @media only screen and (min-width: 992px) {
    margin-top: 0px;
    margin-bottom: 20px;
  }
`;

export const ScrollUp = styled(CharitySectionDivider)``;

export const HideArrow = styled.div`
  &&& .ant-select-dropdown:after {
    bottom: 0;
  }
`;
export const WrapLabel = styled.div`
  &&& {
    .ant-form-item-label {
      margin-bottom: 10px;
      label {
        font-weight: normal;
      }
    }
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      &&& {
        .ant-form-item-label {
          padding: 0;
        }
      }
    }
  }
`;

export const LabelSection = styled.label`
  font-family: ${(props) => props.theme.fontFamily.helveticaNeue} !important;
  font-size: ${(props) => props.theme.fontSize.primary} !important;
  line-height: ${(props) => props.theme.lineHeight.primary};
  color: ${(props) => props.theme.fontColors.textColor} !important;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${(props) => props.theme.fontSize.secondary} !important;
  }
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    word-break: ${(props) => (props.isWordBreak ? 'break-all' : 'normal')};
  }
`;

export const LabelWrapper = styled.span`
  font-family: ${(props) => props.theme.fontFamily.helveticaNeue};
  font-size: ${(props) => props.theme.fontSize.primary};
  line-height: ${(props) => props.theme.lineHeight.primary};
  color: ${(props) => props.theme.fontColors.textColor};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${(props) => props.theme.fontSize.secondary};
  }
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    word-break: ${(props) => (props.isWordBreak ? 'break-all' : 'normal')};
  }
`;

export const InputWrapper = styled.div`
  input,
  .ant-select-selection--single {
    height: 40px;
  }
  .ant-input {
    border: solid 1px ${(props) => props.theme.colors.border};
    border-radius: 0;
    font-size: ${(props) => props.theme.fontSize.primary};
  }
`;

export const WrapperCol = styled.div`
  display: flex;
  justify-content: space-between;
  width: 55px;
  align-items: center;
`;

export const GrantDropdown = styled(Select)`
  .ant-select-selection {
    display: flex;
    align-items: center;
    border-radius: 0px;
    border: 0.7px solid ${(props) => props.theme.border.pill};
  }
  .ant-select-focused .ant-select-selection,
  .ant-select-selection:focus,
  .ant-select-selection:active {
    border-color: rgba(11, 178, 167, 0.1);
    box-shadow: 0 0 0 1px rgba(11, 178, 167, 0.1);
  }
  .ant-select-selection :hover {
    border-color: rgba(11, 178, 167, 0.1);
  }
  .ant-select-selection__rendered {
    width: 100%;
    margin: 0;
  }
  .ant-select-selection-selected-value div {
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 60px;
    padding-left: 20px;
    white-space: nowrap !important;
    letter-spacing: ${(props) => props.theme.letterSpacing.zero};
  }
  &&& {
    .ant-select-arrow {
      background-color: ${(props) => props.theme.backgroundColor.pill};
      color: ${(props) => props.theme.fontColors.tbody};
      width: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 0px;
      border-left: 0.7px solid ${(props) => props.theme.border.pill};
      margin-top: 0px;
      top: 0.8px;
      bottom: 0px;
      height: 37px;
      right: 1.1px;
    }
  }
`;
export const SelectOptionWrapper = styled.div`
  .ant-select-dropdown:after {
    bottom: 0;
  }
  font-family: ${(props) => props.theme.fontFamily.helveticaNeue};
  color: ${(props) => props.theme.fontColors.thead};
  font-size: ${(props) => props.theme.fontSize.secondary};
  line-height: ${(props) => props.theme.lineHeight.h4};
  padding: 2px 0;
  white-space: normal !important;
  @media only screen and (min-width: 992px) {
    font-size: ${(props) => props.theme.fontSize.primary};
  }
`;
export const SelectDropdown = styled(SelectOptionWrapper)`
  .ant-select-dropdown:after {
    bottom: 0;
  }
  font-family: ${(props) => props.theme.fontFamily.helveticaNeue};
  font-size: ${(props) => props.theme.fontSize.secondary};
  letter-spacing: ${(props) => props.theme.letterSpacing.normal};
  color: ${(props) => props.theme.fontColors.placeholder};
  @media only screen and (min-width: 768px) {
    font-size: ${(props) => props.theme.fontSize.primary};
  }
`;

export const FormContainer = styled(Form)`
  &&& {
    .ant-form-item-control .ant-calendar-picker,
    .ant-input-number {
      width: 100%;
    }
    .ant-form-item-control {
      line-height: ${(props) => props.theme.lineHeight.normal};
    }
    .ant-form-item-label {
      margin-bottom: 10px;
      label {
        font-weight: ${(props) => props.theme.fontWeight.normal};
      }
    }
  }
`;

export const Para = styled.div`
  span {
    display: block;
  }
  font-family: ${(props) => props.theme.fontFamily.helveticaNeue};
  font-size: ${(props) => props.theme.fontSize.primary};
  line-height: ${(props) => props.theme.lineHeight.primary};
  color: ${(props) => props.theme.fontColors.textColor};
  margin-bottom: 30px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${(props) => props.theme.fontSize.secondary};
  }
`;
export const SubSectionLabel = styled(TableLabel)`
  font-family: ${(props) => props.theme.fontFamily.helveticaNeueBold};
  margin: ${(props) => props.margin};
  ${({ boldLetter, theme }) =>
    boldLetter &&
    css`
      color: ${theme.fontColors.headingColor};
    `}
  ${({ normalLetter }) =>
    normalLetter &&
    css`
      color: ${theme.fontColors.thead};
      font-family: ${theme.fontFamily.helveticaNeue};
    `}
`;

export const RadioWrapper = styled.div`
  width: 100%;
  & .ant-radio-wrapper {
    white-space: pre-wrap;
  }
  .ant-form-item {
    margin-bottom: 0px;
  }
  span.ant-radio + * {
    padding-left: 10px;
    padding-right: 0px;
  }
  @media only screen and (min-width: 992px) {
    width: 650px;
  }
`;

export const CommentsMargin = styled.div`
  .ant-form-item {
    margin-bottom: 15px;
  }

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 15px;
    margin-left: 20px;
  }
`;

export const CheckboxMargin = styled(DisplayFlex)`
  margin-bottom: 30px;
  .ant-form-item {
    margin-bottom: 0px;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-left: 20px;
  }
`;

export const CheckboxLabel = styled(LabelWrapper)`
  padding-left: 10px;
`;

export const InputMargin = styled.div`
  .ant-form-item {
    margin-bottom: 40px;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .ant-form-item {
      margin-bottom: 30px;
    }
  }
`;

export const LastInputMargin = styled.div`
  .ant-form-item {
    margin-bottom: 10px;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .ant-col-md-6,
    .ant-col-lg-6,
    .ant-col-xs-24 {
      position: unset;
    }
  }
`;
export const ErrorMsgWrap = styled(ErrorMessage).attrs((props) => ({
  className: 'error-fields',
}))`
  ${(props) =>
    props.noLetterSpace &&
    `
  >div >p {
    letter-spacing: 0px;
  }`};
  text-align: left;
  margin-top: 5px;
  letter-spacing: ${(props) => props.theme.letterSpacing.normal};
  line-height: ${(props) => props.theme.lineHeight.secondary};
  @media (min-width: 992px) {
    line-height: ${(props) => props.theme.lineHeight.primary};
    text-align: ${(props) => (props.center ? 'center' : 'left')};
  }

  &.notice {
    color: ${(props) => props.theme.colors.primaryColor};
  }
`;

export const LastNameWrapper = styled.div`
  @media only screen and (max-width: 991px) {
    margin-left: 0;
    margin-top: 20px;
  }
`;

export const GrantContentWrapper = styled.div`
  position: relative;
  left: 20px;
  top: 5px;
  font-family: ${(props) => props.theme.fontFamily.helveticaNeue};
  font-size: ${(props) => props.theme.fontSize.primary};
  line-height: ${(props) => props.theme.lineHeight.primary};
  letter-spacing: ${(props) => props.theme.letterSpacing.normal};
  color: ${(props) => props.theme.fontColors.textColor};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    left: 0;
  }
`;

export const SearchResultText = styled.p`
  font-family: ${(props) => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${(props) => props.theme.fontSize.heading};
  margin-bottom: 5px;
  color: ${(props) => props.theme.fontColors.textColor};
`;

export const DisplayResultText = styled.p`
  font-family: ${(props) => props.theme.fontFamily.helveticaNeue};
  font-size: ${(props) => props.theme.fontSize.primary};
  margin-bottom: 5px;
  color: ${(props) => props.theme.fontColors.textColor};
`;

export const AddButton = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 20px;
  padding-right: 20px;
  height: 30px;
  width: auto;

  background-color: ${(props) => props.theme.backgroundColor.pill};
  border: solid 1px ${(props) => props.theme.border.pill};
  border-radius: 1rem;
  span {
    font-family: ${(props) => props.theme.fontFamily.helveticaNeueMedium};
    font-size: ${(props) => props.theme.fontSize.secondary};
    color: ${(props) => props.theme.fontColors.primary};
    letter-spacing: ${(props) => props.theme.letterSpacing.zero};
    line-height: ${(props) => props.theme.lineHeight.tertiary};
    padding-top: 2px;
    padding-left: 0.25rem;
    white-space: nowrap;
  }

  img {
    padding-left: 10px;
  }

  @media only screen and (max-width: 991.92px) {
    align-self: center;
    margin-left: 0;
    width: 231px;
  }
`;

export const ButtonWrapper = styled(DisplayFlex)`
  @media only screen and (min-width: 320px) and (max-width: 991px) {
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const GrantGhostButton = styled(GhostButtonComponent)`
  width: ${(props) => (props.width ? props.width : '150px')};
  margin-right: 15px;
  font-size: ${(props) => props.theme.fontSize.primary};
  letter-spacing: ${(props) => props.theme.letterSpacing.normal};
  @media only screen and (min-width: 320px) and (max-width: 991px) {
    width: ${(props) => (props.mobHalfWidth ? '48%' : '100%')};
    margin-right: 0;
    margin-bottom: 15px;
    &:last-child {
      margin-right: 0;
    }
  }
`;

export const ViewAllWrap = styled.div`
  margin-right: 15px;
  @media only screen and (min-width: 320px) and (max-width: 991px) {
    width: 100%;
    margin-right: 0px;
    > button {
      margin-bottom: 15px;
    }
  }
`;
export const GrantPrimaryButtonWrapper = styled.div`
  margin-left: auto;
  width: ${(props) => (props.width ? props.width : '150px')};
  font-size: ${(props) => props.theme.fontSize.primary};
  @media only screen and (min-width: 320px) and (max-width: 991px) {
    width: ${(props) => (props.mobHalfWidth ? '48%' : '100%')};
    margin-bottom: 20px;
  }
`;

export const GrantInputRadio = styled.div`
  display: flex;
  margin-bottom: 20px;
  @media only screen and (min-width: 992px) {
    margin-bottom: 30px;
  }
`;

export const CustomizedIcon = styled(Icon)`
  color: ${theme.fontColors.primary};
`;

export const GrantScheduleTableFooter = styled.div`
  border-top: solid 1px ${(props) => props.theme.colors.border};
  border-bottom: solid 1px ${(props) => props.theme.colors.border};
  margin-bottom: 40px;
  @media only screen and (min-width: 992px) {
    margin-bottom: 49px;
  }
  .ant-col {
    padding: 20px 0px 20px 20px !important;
  }
  .label {
    font-family: ${(props) => props.theme.fontFamily.helveticaNeue};
    font-size: ${(props) => props.theme.fontSize.primary};
    line-height: ${(props) => props.theme.lineHeight.primary};
    color: ${(props) => props.theme.fontColors.thead};
  }
  .total-amount {
    font-family: ${(props) => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${(props) => props.theme.fontSize.primary};
    line-height: ${(props) => props.theme.lineHeight.primary};
    letter-spacing: ${(props) => props.theme.letterSpacing.zero};
    color: ${(props) => props.theme.fontColors.headingColor};
  }
  .add-grant-button-wrap {
    @media only screen and (max-width: 576px) {
      display: inline-flex;
      justify-content: flex-end;
    }
  }
  button {
    border: solid 1px ${(props) => props.theme.colors.border};
    background-color: ${(props) => props.theme.backgroundColor.pill};
    border-radius: 25px;
    font-family: ${(props) => props.theme.fontFamily.helveticaNeueMedium};
    font-size: ${(props) => props.theme.fontSize.secondary};
    line-height: ${(props) => props.theme.lineHeight.normal};
    letter-spacing: ${(props) => props.theme.letterSpacing.zero};
    color: ${(props) => props.theme.fontColors.primary};
    padding: 6px 20px;
  }
`;

export const GrantSecondaryButtonComponent = styled(SecondaryButtonComponent)`
  font-family: ${(props) => props.theme.fontFamily.helveticaNeueMedium};
  font-size: ${(props) => props.theme.fontSize.secondary};
  > span {
    font-style: normal;
    font-stretch: normal;
    line-height: ${(props) => props.theme.lineHeight.normal};
    letter-spacing: ${(props) => props.theme.letterSpacing.zero};
  }
  @media only screen and (max-width: 991.92px) {
    width: 95px;
  }
`;

export const LinkWrapper = styled(UnderlineLink)`
  font-family: ${(props) => props.theme.fontFamily.helveticaNeue};
  font-size: ${(props) =>
    props.tableFont
      ? props.theme.fontSize.tableFont
      : props.theme.fontSize.primary};
  color: ${(props) => props.theme.fontColors.primary};
  text-decoration: underline;
  line-height: ${(props) => props.theme.lineHeight.primary};
  cursor: pointer;
  letter-spacing: ${(props) => props.theme.letterSpacing.zero};
  ${({ inline }) =>
    inline &&
    css`
      display: inline;
    `}
`;

export const GrantNameField = styled.div`
  font-family: ${(props) => props.theme.fontFamily.helveticaNeue};
  font-size: ${(props) => props.theme.fontSize.tableFont};
  line-height: ${(props) => props.theme.lineHeight.primary};
  color: ${(props) => props.theme.fontColors.thead};
  letter-spacing: ${(props) => props.theme.letterSpacing.zero};
  ${({ NoBorder }) =>
    NoBorder &&
    css`
      color: ${(props) => props.theme.fontColors.textColor};
    `}
`;

export const DateSelector = styled(DatePicker)`
  .ant-calendar-picker-clear {
    display: none;
  }
  .ant-calendar-picker-input {
    font-size: ${(props) => props.theme.fontSize.primary};
    font-family: ${(props) => props.theme.fontFamily.helveticaNeue};
    color: ${(props) => props.theme.fontColors.thead};
  }
`;

export const ExpandableLabel = styled.h3`
  font-family: ${(props) => props.theme.fontFamily.helveticaNeue};
  font-size: ${(props) => props.theme.fontSize.secondary};
  margin: 0;
  ${({ header, theme }) =>
    header &&
    `
    margin-bottom: 5px;
    font-family: ${theme.fontFamily.helveticaNeueBold};
  `}
`;

export const StatusSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-top: 20px;
  @media (min-width: 992px) {
    flex-wrap: normal;
    padding-top: 30px;
  }
  > div {
    width: 100%;
    @media (min-width: 992px) {
      width: auto;
    }
    &:not(:first-child) {
      @media (min-width: 992px) {
        border-left: 1px solid ${(props) => props.theme.colors.border};
        padding-left: 30px;
        margin-left: 30px;
      }
    }
  }
`;

export const CharityChangeLink = styled.div`
  > a {
    display: block;
    @media (min-width: 992px) {
      display: inline-block;
    }
  }
`;

export const GrantDatePicker = styled(DatePicker)`
  ${({ displayNone }) =>
    displayNone &&
    `
    input.ant-calendar-picker-input {
      display: none;
    }
    .ant-calendar-picker-icon {
      display: none;
    }
  `}
  .ant-calendar-picker-input.ant-input {
    font-family: ${(props) => props.theme.fontFamily.helveticaNeue};
    font-size: ${(props) => props.theme.fontSize.secondary};
    line-height: ${(props) => props.theme.lineHeight.secondary};
    letter-spacing: ${(props) => props.theme.letterSpacing.zero};
    color: ${(props) => props.theme.fontColors.thead};
    @media (min-width: 992px) {
      font-size: ${(props) => props.theme.fontSize.primary};
      line-height: ${(props) => props.theme.lineHeight.primary};
    }
  }
  .ant-calendar-picker-clear {
    display: none;
  }
`;

export const InputSection = styled(InputField)`
  padding: 4px 11px !important;
  @media only screen and (max-width: 767px) {
    max-width: unset !important;
  }
`;

export const GrantSuccessMessage = styled.div`
  padding: 12px 0px;
  > div > p {
    font-family: ${(props) => props.theme.fontFamily.helveticaNeueLight};
    font-size: ${(props) => props.theme.fontSize.h4};
    color: ${(props) => props.theme.fontColors.green};
  }
  @media only screen and (min-width: 320px) and (max-width: 991px) {
    > div > p {
      font-size: ${(props) => props.theme.fontSize.h5} !important;
    }
  }
`;

export const CustomPagesHeading = styled(PagesHeading)`
  @media only screen and (max-width: 576px) {
    font-size: ${(props) => props.theme.fontSize.h2};
  }
`;
export const StatusSectionPrint = styled(StatusSection)`
  padding-top: 10px;
`;
export const SectionMediumDividerPrint = styled(SectionMediumDivider)`
  margin-top: 15px;
  margin-bottom: 10px;
`;

export const CharityTabHeading = styled.div`
  font-size: ${(props) => props.theme.fontSize.primary};
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    font-size: ${(props) => props.theme.fontSize.secondary};
  }
`;

export const Title = styled.div`
  font-family: ${(props) => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${(props) => props.theme.fontSize.primary};
  font-style: ${(props) => props.theme.fontWeight.normal};
  font-stretch: ${(props) => props.theme.fontStretch.normal};
  line-height: ${(props) => props.theme.lineHeight.primary};
  letter-spacing: ${(props) => props.theme.letterSpacing.zero};
  color: ${(props) => props.theme.fontColors.headingColor};
`;

export const AccountWordWrap = styled.span`
  word-break: break-word;
`;

export const AlertWrap = styled.div`
  > div > p {
    font-family: ${(props) => props.theme.fontFamily.helveticaNeue};
    font-size: ${(props) => props.theme.fontSize.primary};
    font-weight: ${(props) => props.theme.fontWeight.normal};
    font-style: normal;
    font-stretch: ${(props) => props.theme.fontStretch.normal};
    line-height: ${(props) => props.theme.lineHeight.primary};
    letter-spacing: normal;
    text-align: center;
    color: ${(props) => props.theme.fontColors.textColor};
    @media (min-width: 320px) and (max-width: 768px) {
      > div > p {
        font-size: ${(props) => props.theme.fontSize.secondary};
        letter-spacing: ${(props) => props.theme.letterSpacing.normal};
      }
    }
  }
`;

export const ClearedDateSection = styled.div`
  margin-top: 30px;
  @media (min-width: 320px) and (max-width: 991px) {
    margin-top: 0px;
  }
`;

const buttonStyle = css`
  ${(props) =>
    props.btnWithMargin &&
    `
  margin-right: 15px;
  `}
  @media only screen and (min-width: 320px) and (max-width: 991px) {
    ${(props) =>
      props.btnWithMargin &&
      `
    margin-right: 0px;
    margin-bottom: 15px;
  `}
  }
`;

export const FlowButtonContainer = styled.div`
  ${buttonStyle}
  ${(props) =>
    props.fitContent &&
    css`
    button {
    width: 100% !important;
    }
  `}
  @media only screen and (min-width: 320px) and (max-width: 991px) {
    ${(props) =>
      props.halfWidth &&
      css`
      width: 48%;
    `}
    button {
      width: 100% !important;
    }
  }
  @media (min-width: 320px) and (max-width: 768px) {
    ${(props) =>
      props.fitContent &&
      css`
      button {
      width: 100% !important;
      }
    `}
  }
`;

export const ViewEditBtnContainer = styled.div`
  ${buttonStyle}
  @media only screen and (min-width: 320px) and (max-width: 991px) {
    width: 100%;
    button {
      width: 100% !important;
    }
  }
`;

export const TableEditBtnWrapper = styled.div`
  > button {
    width: 114px;
  }
`;

export const RecognitionFieldset = styled.fieldset`
  border: none;
`;

export const RecognitionLegend = styled.legend`
  ${headingStyle}
  margin: 0;
  padding: 0;
  border: none !important;
  font-size: ${(props) => props.theme.fontSize.h4} !important;
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    font-size: ${(props) => props.theme.fontSize.h5} !important;
  }
`;
